<template>
  <div class="home antialiased font-sans  flex flex-col h-full">
    <Topbar v-if="showTopbar && hasLoaded" />
    <router-view v-if="hasLoaded"></router-view>
    <div class="text-center flex flex-col h-full justify-center" v-else>
      <h1
        class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight"
      >
        Welcome to PushHike
      </h1>
    </div>
  </div>
</template>

<script>
// import Spinner from "vue-simple-spinner";

// @ is an alias to /src
import Topbar from "@/components/Common/Topbar";

// import ReviewModal from "@/components/Common/ReviewModal";

import { Redirect } from "@shopify/app-bridge/actions";

export default {
  name: "Home",
  components: {
    Topbar
    // Spinner
    // ReviewModal,
    // PromoBanner
  },
  data() {
    return {
      showOnboardingModal: false,
      showReviewModal: false,
      totalRecoveredValue: 0,
      showPromoBanner: false,
      hasLoaded: false,
      isMobile: false,
      showTopbar: false
    };
  },
  async created() {
    const response = await this.$store.dispatch("getConfig");
    if (response.needsOauth && response.oauthUrl) {
      const app = this.$store.getters.getAppBridgeApp;
      const redirect = Redirect.create(app);
      redirect.dispatch(Redirect.Action.REMOTE, response.oauthUrl);
      return;
    }

    this.hasLoaded = true;

    const store = response.store;
    const route = this.$route.path;
    console.log("route", route);
    this.setEmailOnCrisp();

    const shopifyPlan = this.$store.getters.getShopifyPlan;
    if (this.isNotShopifyStaff(shopifyPlan)) {
      this.showTopbar = true;
    }

    if (store && store.isPlanSelected) {
      if (route === "/") {
        this.$router.push({ name: "Overview" });
        return;
      }
    }

    if (store && store.isPlanSelected === false) {
      this.$router.push({ name: "Plan" });
    }
  },
  methods: {
    onModalClose() {
      this.showOnboardingModal = false;
    },
    isNotShopifyStaff(planName) {
      return ["custom", "staff", "staff_business"].indexOf(planName) === -1;
    },

    checkForOnboarding() {
      const config = this.$store.getters.getConfig;
      if (
        config &&
        config.createdAt > 1652433630 &&
        config.hasCompletedOnboarding === false
      ) {
        this.$router.push({ name: "Onboarding" });
      }
    },
    parseJwt(token) {
      var base64Payload = token.split(".")[1];
      var payload = Buffer.from(base64Payload, "base64");
      return JSON.parse(payload.toString());
    },
    async setEmailOnCrisp() {
      const response = await this.$store.dispatch("getUser");
      // eslint-disable-next-line
      if (response && response.user && response.user.email && $crisp) {
        // eslint-disable-next-line
        $crisp.push(["set", "user:email", [response.user.email]]);
        const store = this.$store.getters.getStore;
        const shopifyPlan = this.$store.getters.getShopifyPlan;
        // eslint-disable-next-line
        $crisp.push([
          "set",
          "session:data",
          [
            [
              ["plan", store.plan],
              ["hasReviewed", store.hasReviewed],
              ["shopOrigin", store.shopOrigin],
              ["storeId", store.id],
              ["shopifyPlan", shopifyPlan]
            ]
          ]
        ]);
      }
    },

    getTokenFromUrl() {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop)
      });
      return params.token;
    }
  }
};
</script>
